import React from 'react';

import { iconBaseProps, type IconProps } from './IconBase';

const MapIcon: React.FC<IconProps> = props => (
  <svg {...iconBaseProps} {...props}>
    <path d="M9 4 3 6.5v13L9 17l6 3 6-2.5v-13L15 7 9 4Z" />
    <line x1="9" y1="4" x2="9" y2="17" />
    <line x1="15" y1="7" x2="15" y2="20" />
  </svg>
);

export default MapIcon;
